export const PROP_DESCRIPTION =
  'You will get the info from your Planning IT entry or your PM'
export const CONTROLLING_INFO_PROPS = {
  costCenter: {
    type: 'string',
    title: '*Cost center',
    description: PROP_DESCRIPTION,
  },
  costNumber: {
    type: 'string',
    title: '*Internal Order Number',
    description: PROP_DESCRIPTION,
  },
  pspNumber: {
    type: 'string',
    title: 'PSP number',
    description: PROP_DESCRIPTION,
  },
  isaNumber: {
    type: 'string',
    title: 'ISA number',
    description: PROP_DESCRIPTION,
  },
  purchaseOrder: {
    type: 'string',
    title: 'Purchase Order',
    description: PROP_DESCRIPTION,
  },
}

export const addAwsAccountId = (schema, isWhitelisted) =>
  isWhitelisted
    ? {
        ...schema,
        properties: {
          ...schema.properties,
          awsAccountId: {
            type: 'string',
            title: 'AWS account id',
            description: 'Only visible and editable for admins',
          },
        },
      }
    : schema

export const removeMembers = (schema) => {
  const withoutMembers = { ...schema }
  withoutMembers.properties = {}
  Object.entries(schema.properties).forEach(([key, value]) => {
    if (key !== 'members') {
      withoutMembers.properties[key] = value
    }
  })
  return withoutMembers
}

export const addAdvancedBooking = (schema, isCreating, arts, tenantInfo) => {
  if (isCreating) {
    return schema
  }
  const extended = { ...schema }
  extended.required = [...schema.required, 'nebulaControllingInformation']
  const nebulaControllingInformation = {
    type: 'object',
    title: 'Nebula Controlling Information',
    description:
      'Cost number and and cost center are now required for editing a tenant. ' +
      'This is to remove inconsistencies in the current data where number and center have been mixed up or not provided. ' +
      'Please note that they are always distinct.',
    properties: CONTROLLING_INFO_PROPS,
  }
  extended.required = [...schema.required, 'gbsControllingInformation']
  const gbsControllingInformation = {
    type: 'object',
    title: 'GBS Controlling Information',
    description: PROP_DESCRIPTION,
    properties: CONTROLLING_INFO_PROPS,
  }
  extended.required = [...schema.required, 'b2xCoreControllingInformation']
  const b2xCoreControllingInformation = {
    type: 'object',
    title: 'B2XCore Controlling Information',
    description: PROP_DESCRIPTION,
    properties: CONTROLLING_INFO_PROPS,
  }
  extended.properties = {
    ...schema.properties,
    nebulaControllingInformation,
    agileReleaseTrain: {
      type: 'string',
      title: 'Agile Release Train (ART)',
      description: 'Agile Release Train (ART)',
      enum: ['', ...arts.map((art) => art.key)],
      enumNames: ['Please select', ...arts.map((art) => art.value)],
      default: '',
    },
  }

  if (tenantInfo.providers?.includes('gbs')) {
    extended.properties = {
      ...extended.properties,
      gbsControllingInformation,
    }
  }

  if (tenantInfo.providers?.includes('b2xcore')) {
    extended.properties = {
      ...extended.properties,
      b2xCoreControllingInformation,
    }
  }
  return extended
}

export const getSchema = ({
  schema,
  arts,
  tenantInfo,
  sample,
  isCreating,
  allTenants,
  isWhitelisted,
  receiveSchema,
}) => {
  const tenantAcronyms = Object.keys(allTenants)
  if (!schema || !tenantAcronyms.length) {
    return null
  }
  if (schema.properties.hasOwnProperty('experiences')) {
    const experiences = schema.properties.experiences.items
    experiences.enum = []
    experiences.enumNames = []
    experiences.appendEntry = (k, v) => {
      experiences.enum.push(k)
      experiences.enumNames.push(v)
    }
    experiences.appendEntry('no_exp', 'None')
    tenantAcronyms.forEach((acronym) => {
      if (allTenants[acronym].type?.includes('cms')) {
        experiences.appendEntry(acronym, allTenants[acronym].name)
      }
    })
  }

  receiveSchema(schema, sample)

  return removeMembers(
    addAwsAccountId(
      addAdvancedBooking(schema, isCreating, arts, tenantInfo),
      isWhitelisted,
    ),
  )
}
